<style lang="less" scoped>
  @import "../../../vars.less";
  .list {
    list-style: none;
    margin: 0;
  }
  .item {
    position: relative;
    padding: @space-normal;
    padding-left: calc(@space-normal + 4px);
    margin-bottom: @space-small;
    background-color: #fff;
    color: @text-color;
    font-size: 14px;
  }
  .title-container {
    display: flex;
    color: @text-color-important;
  }
  .title {
    flex: auto;
    font-size: 16px;
    font-weight: bold;
  }
  .title-right {
    flex: none;
    align-self: right;
    display: flex;
    justify-content: center;
    .icon {
      font-size: 20px;
      margin-right: @space-small;
    }
  }
  .done {
    .title-right {
      color: @warning-color;
    }
    .status-bar {
      background-color: @warning-color;
    }
  }
  .underway {
    .title-right {
      color: @primary-color;
    }
    .status-bar {
      background-color: @primary-color;
    }
  }
  .status-bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
  }
  .content {
    display: flex;
    margin-top: @space-normal;
  }
  .content-left {
    flex: auto;
  }
  .content-right {
    position: relative;
    right: -6px;
    flex: none;
    padding-left: @space-small;
    display: flex;
    align-items: center;
    font-size: 20px;
  }
  .content-item {
    margin: 0;
    display: flex;
    line-height: 1.8;
  }
  .label {
    flex: none;
    color: @text-color-secondary;
    margin-right: @space-normal;
  }
  .label:after {
    content: ":"
  }
  .value {
    flex: auto;
  }
</style>

<template>
  <page-container class="special-delivery-list"
    :title="$t('特殊发货')" infinity :safeAreaInsetBottom="false"
    :loading="loading"
    :finished="finished"
    :empty="!list.length"
    @load="getList">
      <ul class="list">
        <li v-for="item of list" :key="item.orderNumber"
          class="item"
          :class="{
            done: item.CaseStatus === '进行中',
            underway: item.CaseStatus === '完结'
          }"
          @click="() => go2Detail(item)">
          <div class="status-bar" />
          <div class="title-container">
            <span class="title">
              {{ $t('SO') }}: {{ item.order_number }}
            </span>
            <span class="title-right">
              <van-icon v-if="item.CaseStatus === '完结'" name="passed" class="icon"/>
              <van-icon v-if="item.CaseStatus === '进行中'" name="underway-o" class="icon"/>
              {{ item.CaseStatus === '进行中' ? $t('进行中') : $t('已完结') }}
            </span>
          </div>
          <div class="content">
            <div class="content-left">
              <p class="content-item">
                <span class="label">{{ $t('项目名称') }}</span>
                <span class="value">{{ item.ProjectName }}</span>
              </p>
              <p class="content-item">
                <span class="label">{{ $t('加急原因') }}</span>
                <span class="value">{{ item.ReasonCategoryType }}</span>
              </p>
              <p class="content-item">
                <span class="label">{{ $t('提交日期') }}</span>
                <span class="value">{{ item.CaseCreateDate }}</span>
              </p>
            </div>
            <div class="content-right">
              <van-icon name="arrow" />
            </div>
          </div>
        </li>
      </ul>
  </page-container>
</template>

<script>
import { Icon } from 'vant'
import PageContainer from '../../../components/PageContainer.vue'

export default {
  name: 'special-delivery-list',
  components: {
    'van-icon': Icon,
    // 'van-button': Button,
    PageContainer
  },
  data () {
    return {
      conditions: {
        ...this.$route.query,
        PageSize: 10,
        PageIndex: 1,
        IsPageView: true
      },
      list: [],
      loading: false,
      finished: false
    }
  },
  methods: {
    getList () {
      this.$apis.care.getSpecialDeliveries(
        this.conditions,
        loading => (this.loading = loading)
      ).then(res => {
        if (res) {
          if (res.SpecialDeliveryList.length) {
            this.list = this.list.concat(res.SpecialDeliveryList)
            this.conditions.PageIndex += 1
          }
          if (res.SpecialDeliveryList.length < this.conditions.PageSize) {
            this.finished = true
          }
        }
      })
    },
    go2Detail (item) {
      this.$router.push({
        name: 'special-delivery-detail',
        params: {
          stackType: 'push'
        },
        query: {
          InstanceId: item.FlowInstanceId
        }
      })
    }
  },
  mounted () {
    this.getList()
  }
}
</script>
